import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Table, Card, Input, Button, Space, Typography } from 'antd';
import { SearchOutlined, } from '@ant-design/icons';
import EtradeDataFetcher from '../EtradeDataFetcher';
import Highlighter from 'react-highlight-words';
import * as common from "./Common";
import useInterval from './useInterval';
import { v4 as uuidv4 } from 'uuid';



const ETrade = () => {
  useEffect(() => {
  }, [])

  const [buylist, setBuylist] = React.useState(null);
  const [mgrStat, setMgrStat] = React.useState(0);
  const [accInfo, setAccInfo] = React.useState(null);
  const [post, setPost] = React.useState(null);
  const [codes, setCodes] = React.useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const searchInput = useRef(null);
  const [searchText, setSearchText] = React.useState(null);
  const [searchedColumn, setSearchedColumn] = React.useState(null);
  const [state, setState] = useState({ searchText: '', searchedColumn: '' })
  const [filtered_post, setFilteredPost] = React.useState(null);

  const ShowMgrStatus = useMemo(() => {
    return mgrStat === 0 ? (
      <font color="red">중지</font>
    ) : (
      <font color="green">동작중</font>
    );
  }, [mgrStat]);

  // 타이머에 의해 API데이타 가져오기
  useInterval(() => {
    //console.log("call apis by timer")
    EtradeDataFetcher.getEtrade().then(({ codes, datas }) => {
      setCodes(codes);
      setPost(datas);
    })

    EtradeDataFetcher.getManagerState().then((result) => {
      setMgrStat(result);
    })
  }, 30000);

  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button onClick={() => handleReset(confirm, clearFilters)} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    onFilterDropdownOpenChange: visible => {
      if (visible) {
        setTimeout(() => searchInput && searchInput.current && searchInput.current.select()
        )
      }
    },
    render: text =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  const handleReset = (confirm, clearFilters) => {
    clearFilters();
    setState({ searchText: '' });
    confirm();
  };

  React.useEffect(() => {
    EtradeDataFetcher.getEtrade().then(({ codes, datas }) => {
      setCodes(codes);
      setPost(datas);
      setFilteredPost(datas);
    });

    EtradeDataFetcher.getBuyList().then(result => {
      setBuylist(result);
    });

    EtradeDataFetcher.getManagerState().then(result => {
      setMgrStat(result);
    });

    EtradeDataFetcher.getAccountInfo().then(result => {
      setAccInfo(result);
    });

    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkIsMobile(); // 컴포넌트가 마운트되었을 때 한 번 실행
    window.addEventListener('resize', checkIsMobile); // 창 크기가 변경될 때마다 실행
    return () => {
      window.removeEventListener('resize', checkIsMobile); // 컴포넌트가 언마운트될 때 이벤트 리스너 제거
    };

  }, []);

  if (!post) return null;

  // 문자열을 오름차순으로 소팅하는 콜백 함수
  const stringSorter = (val1, val2) => {
    return val1.localeCompare(val2);
  };

  const handleCodeClick = (code) => {
    //console.log('텍스트가 클릭되었습니다:', code);

    if (code === '000000') {
      setFilteredPost(post);
    }
    else {
      const filtered = post.filter(item => item.z_code === code).map(item => item);
      //console.log(filtered);
      setFilteredPost(filtered);
    }
  };

  const col_buylist = [
    {
      title: "종목",
      dataIndex: "z_name",
      fixed: "left",
      key: "z_name",
      width: 30,
      ...getColumnSearchProps('z_name'),
      render: (text, record) => <a href={`https://finance.naver.com/item/main.nhn?code=` + record.z_code} target='_blank' rel='noopener noreferrer nofollow'>{text}</a>
    },
    {
      title: "코드",
      dataIndex: "z_code",
      key: "z_code",
      width: 20,
      ...getColumnSearchProps('z_code'),
      render: (text, record) => common.renderCode(text)
    },
    {
      title: "등록일시",
      dataIndex: "z_reg_dt",
      width: 20,
      sorter: (a, b) => a.z_reg_dt - b.z_reg_dt,
      render: (text, record) => common.UnixTimeToStringDateIncludePassDay(text)
    },
    {
      title: "등록가격",
      dataIndex: "z_reg_price",
      width: 15,
    },
    {
      title: "평단가",
      dataIndex: "z_avg_price",
      width: 15,
      sorter: (a, b) => a.z_avg_price - b.z_avg_price,
    },
    {
      title: "현재가격",
      dataIndex: "z_cur_price",
      width: 25,
      sorter: (a, b) => a.z_cur_price - b.z_cur_price,
      render: (text, record) => common.calcRemainPercentage(record.z_cur_price, record.z_stop_price)
    },
    {
      title: "보유여부",
      dataIndex: "z_have",
      width: 15,
      sorter: (a, b) => stringSorter(a.z_have, b.z_have),
    },
    {
      title: "동작유무",
      dataIndex: "z_act",
      width: 15,
      sorter: (a, b) => stringSorter(a.z_act, b.z_act),
    },
    {
      title: "STOP유무",
      dataIndex: "z_stop",
      width: 15,
      sorter: (a, b) => stringSorter(a.z_stop, b.z_stop),
    },
  ]

  const codes_col = [
    {
      title: "거래한 종목",
      dataIndex: "z_code",
      fixed: "left",
      key: "z_code",
      width: 30,
      render: (text, record) => {
        return (
          <Typography onClick={() => handleCodeClick(text)}>
            {record.z_name} ({text})
          </Typography >
        );
      }
    },
  ]

  const col_accinfo = [
    {
      title: "종목",
      dataIndex: "z_name",
      fixed: "left",
      key: "z_name",
      width: 30,
      ...getColumnSearchProps('z_name'),
      render: (text, record) => common.renderJongMok(record)
    },
    {
      title: "코드",
      dataIndex: "z_code",
      key: "z_code",
      width: 18,
      ...getColumnSearchProps('z_code'),
      render: (text, record) => common.renderCode(text)
    },
    {
      title: "BT",
      dataIndex: "z_regdt",
      width: 26,
      render: (text, record) => common.UnixTimeToStringDateTime(text)
    },

    {
      title: "QTY",
      dataIndex: "z_qty",
      width: 13,
    },
    {
      title: "BP",
      dataIndex: "z_buy_price",
      width: 18,
    },
    {
      title: "CP",
      dataIndex: "z_cur_price",
      width: 18,
    },
    {
      title: "EXP",
      dataIndex: "z_profit",
      sorter: (a, b) => a.z_profit - b.z_profit,
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => (common.changeColor(text, record.z_profit)),
      width: 18,
    },
    {
      title: "ERATE",
      dataIndex: "z_earn_rate",
      width: 18,
    },
  ]

  const columns = [
    {
      title: "종목",
      dataIndex: "z_name",
      fixed: "left",
      key: "z_name",
      width: 30,
      ...getColumnSearchProps('z_name'),
      render: (text, record) => common.renderJongMok(record)
    },
    {
      title: "코드",
      dataIndex: "z_code",
      key: "z_code",
      width: 18,
      ...getColumnSearchProps('z_code'),
      render: (text, record) => common.renderCode(text)
    },
    {
      title: "상태",
      dataIndex: "z_state",
      filters: common.state_filters,
      onFilter: (value, record) => {
        if (record.z_state.toString() === common.state_filters[value].text)
          return record;
      },
      width: 18,
    },
    {
      title: "BT",
      dataIndex: "z_buydt",
      width: 26,
      render: (text, record) => common.UnixTimeToStringDateTime(text)
    },
    {
      title: "BP",
      dataIndex: "z_buyprice",
      width: 18,
    },
    {
      title: "ST",
      dataIndex: "z_selldt",
      width: 26,
      render: (text, record) => common.UnixTimeToStringDateTime(text)
    },
    {
      title: "SP",
      dataIndex: "z_sellprice",
      width: 18,
    },
    {
      title: "QTY",
      dataIndex: "z_qty",
      width: 13,
    },
    {
      title: "EXP",
      dataIndex: "z_profit",
      sorter: (a, b) => a.z_profit - b.z_profit,
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => (common.changeColor(text, record.z_profit)),
      width: 18,
    },
  ];


  return (
    <div>
      <p key={uuidv4()} variant="body2">자동매매 프로그램 동작상태 : {ShowMgrStatus}</p>

      <Card title="보유현황" size="small" bordered={true}>
        <Table
          bordered
          size="small" scroll={{ x: 1024 }}
          rowKey={"code"}
          dataSource={accInfo}
          columns={col_accinfo}
          pagination={{ defaultPageSize: 15 }}
        />
      </Card>
      <h1></h1>
      {/*
      <Card title="매수대기 종목" size="small" bordered={true}>
        <Table
          bordered
          size="small" scroll={{ x: 1024 }}
          rowKey={"code"}
          dataSource={buylist}
          columns={col_buylist}
          pagination={{ defaultPageSize: 15 }}
        />
      </Card>
      <h1></h1>
      */}
      <Card title="종목별 상세 이력" size="small" bordered={true}>
        <div className='volab-etrade-history-table'>
          <div className='left'>
            <Table
              bordered
              size="small"
              rowKey={"code"}
              dataSource={codes}
              columns={codes_col}
              pagination={{ defaultPageSize: 15 }}
            />
          </div>
          <div className='right'>
            <Table
              bordered
              size="small"
              rowKey={"code"}
              dataSource={filtered_post}
              columns={columns}
              pagination={{ defaultPageSize: 25 }}
              scroll={{ x: true }}
            />
          </div>
        </div>
      </Card>
    </div>
  )
}

export default ETrade;